'use strict';

export default class AddController {

  /*@ngInject*/
  constructor($http, $state) {
    this.$http = $http;
    this.$state = $state;
    this.newGroup = {};
  }

  save() {
    this.$http.post(`/api/betaGroups`, this.newGroup).then(res => {
      this.$state.go('^');
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/betagroups/add/add.controller.js